// @ts-nocheck

import { type StateType } from '../../../states';
import { type PlayerState } from '../../../states/entities/players';
import { type EntitiesPlayers } from '../../../states/entities/players';
import { type Selector } from '../../../types/selectors';
import { getPlayerIdFromProps } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};

export const selectEntitiesPlayers: Selector<EntitiesPlayers> = (state: StateType) =>
  selectEntitiesState(state).players ?? emptyObject;

type EntitiesPlayersSelectorProps = {
  playerId?: number;
};

export const selectEntitiesPlayersEntity: Selector<PlayerState | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => {
  const playerId = getPlayerIdFromProps(state, props);

  if (playerId) {
    return selectEntitiesPlayers(state)[playerId];
  }
};

export const selectEntitiesPlayersEntityPlayerId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.playerId;

export const selectEntitiesPlayersEntitySrPlayerId: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.srPlayerId;

export const selectEntitiesPlayersEntityName: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.name;

export const selectEntitiesPlayersEntityShortname: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.shortname;

export const selectEntitiesPlayersEntityTeam: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.team;

export const selectEntitiesPlayersEntityStarter: Selector<boolean | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.starter;

export const selectEntitiesPlayersEntityDisplayOrder: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.displayOrder;

export const selectEntitiesPlayersEntityJerseyNumber: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.jerseyNumber;

export const selectEntitiesPlayersEntityLineupOrder: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.lineupOrder;

export const selectEntitiesPlayersEntityMatchTimeIn: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.matchTimeIn;

export const selectEntitiesPlayersEntityStoppageTimeIn: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.stoppageTimeIn;

export const selectEntitiesPlayersEntityMatchTimeOut: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.matchTimeOut;

export const selectEntitiesPlayersEntityStoppageTimeOut: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.stoppageTimeOut;

export const selectEntitiesPlayersEntitySubstitutedBy: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.substitutedBy;

export const selectEntitiesPlayersEntitySubstitutes: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.substitutes;

export const selectEntitiesPlayersEntityYellowCard: Selector<boolean | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.yellowCard;

export const selectEntitiesPlayersEntityYellowRedCard: Selector<boolean | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.yellowRedCard;

export const selectEntitiesPlayersEntityRedCard: Selector<boolean | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.redCard;

export const selectEntitiesPlayersEntityYellowCardMatchTime: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.yellowCardMatchTime;

export const selectEntitiesPlayersEntityYellowCardStoppageTime: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.yellowCardStoppageTime;

export const selectEntitiesPlayersEntityYellowRedCardMatchTime: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.yellowRedCardMatchTime;

export const selectEntitiesPlayersEntityYellowRedCardStoppageTime: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.yellowRedCardStoppageTime;

export const selectEntitiesPlayersEntityRedCardMatchTime: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.redCardMatchTime;

export const selectEntitiesPlayersEntityRedCardStoppageTime: Selector<string | null | undefined> = (
  state: StateType,
  props: EntitiesPlayersSelectorProps = {},
) => selectEntitiesPlayersEntity(state, props)?.redCardStoppageTime;
